<header
  class="header"
  role="navigation"
  [class.visually-hidden]="!showHeader()"
  *transloco="let t">
  <div class="header_actions">
    <!-- Log in -->
    <span class="header_text hide-tablet">{{ t('auth.login.have-account') }}</span>

    <!-- This link needs to reload the page to get backend login page -->
    <a
      class="btn __wider __s"
      [href]="loginUrl()"
      >{{ t('common.login') }}</a
    >
  </div>
</header>
